/* loaded by smart-asset */
export default require("./assets/drop-zone-red-pallet.i.svg")